import React from 'react';
import Badge from '../ui/Badge';
import { titleCase } from '../../api/blueprints';

/** Library / organization card: role, industry, seniority, version, top topics + weights. */
export default function BlueprintCard({ blueprint, actions }) {
  const b = blueprint;
  const topics = (b.topTopics || []).slice().sort((x, y) => y.weight - x.weight).slice(0, 6);
  return (
    <div className="card rounded-xl p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-semibold text-ink truncate" title={b.name}>{b.name}</div>
          <div className="text-xs text-ink-muted mt-0.5">
            {[b.roleFamily, b.industry && titleCase(b.industry), b.seniority && titleCase(b.seniority)].filter(Boolean).join(' · ')}
          </div>
        </div>
        <div className="flex flex-col items-end gap-1 shrink-0">
          {b.currentVersionNo ? <Badge label={`v${b.currentVersionNo}`} color="teal" /> : <Badge label="Draft" color="amber" />}
          {b.genericFallback && <Badge label="Fallback" color="gray" />}
        </div>
      </div>
      {topics.length > 0 && (
        <ul className="space-y-1">
          {topics.map((t) => (
            <li key={t.topic} className="flex items-center gap-2 text-xs">
              <span className="flex-1 truncate text-slate-700">{t.topic}{t.mustAsk ? ' (must ask)' : ''}</span>
              <span className="w-20 h-1.5 rounded-full bg-slate-100 overflow-hidden">
                <span className="block h-full bg-teal-500" style={{ width: `${Math.min(100, t.weight)}%` }} />
              </span>
              <span className="w-9 text-right tabular-nums text-slate-500">{t.weight}%</span>
            </li>
          ))}
        </ul>
      )}
      <div className="text-[11px] text-slate-400">
        {b.updatedAt ? `Updated ${new Date(b.updatedAt).toLocaleDateString()}` : ''}
      </div>
      {actions && <div className="flex flex-wrap gap-2 pt-1 border-t border-slate-100">{actions}</div>}
    </div>
  );
}
